




















































import { utils } from '@easygenerator/fragment-sdk';
import { Component, Vue } from 'vue-property-decorator';
import PasswordField from './common/PasswordField.vue';
import CommonForm from './common/CommonForm.vue';
import { DEFAULT_PASSWORD_RULES, PasswordRules } from '../utils/password-rules';
import Config from '../config';
const config = Config.getInstance();

const STATE_INVALID = 'state-invalid';
const PASSWORD_POLICY = 'password-policy';
const TOO_MANY_REQUESTS = 429;

const requestErrorKey = (status?: number) => (status === TOO_MANY_REQUESTS ? 'tooManyAttempts' : 'somethingWentWrong');

type StateDescription = {
  exists: boolean;
  passwordRules?: PasswordRules;
  loginUrl?: string;
};

@Component({
  components: {
    PasswordField,
    CommonForm
  }
})
export default class ForgotPassword extends Vue {
  isStateChecked = false;

  showLinkExpired = false;

  passwordRules: PasswordRules = DEFAULT_PASSWORD_RULES;

  loginUrl = '';

  stateErrorKey = '';

  submitErrorKey = '';

  password = '';

  confirmationEmailSent = false;

  emailToConfirm: string | null = '';

  state: string | null = '';

  isPasswordInvalid = false;

  disableSubmit = true;

  updatePassword(value: string) {
    this.password = value;
    this.isPasswordInvalid = false;
    this.submitErrorKey = '';
  }

  getValueFromQueryString(key = 'token') {
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.get(key);
  }

  async describeState(state: string): Promise<StateDescription> {
    const description = await utils.HttpWrapper.get<StateDescription>(`/api/credentials/state-exists?state=${state}`);
    return description || { exists: false };
  }

  async beforeMount() {
    const state = this.getValueFromQueryString('state');
    if (state) {
      try {
        this.applyStateDescription(await this.describeState(state));
      } catch (err) {
        this.stateErrorKey = requestErrorKey(err.status);
      }
    } else {
      this.showLinkExpired = true;
    }
    this.isStateChecked = true;
  }

  applyStateDescription({ exists, passwordRules, loginUrl }: StateDescription) {
    this.showLinkExpired = !exists;
    this.passwordRules = passwordRules || DEFAULT_PASSWORD_RULES;
    this.loginUrl = loginUrl || '';
  }

  passwordValid(value: boolean) {
    this.disableSubmit = !value;
  }

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('email')) {
      this.emailToConfirm = urlParams.get('email');
    }

    if (urlParams.has('state')) {
      this.state = urlParams.get('state');
    }
  }

  async submitForm(): Promise<void> {
    try {
      const url = '/api/credentials/change-password';

      const data = {
        state: this.state,
        password: this.password
      };

      const { returnUrl } = await utils.HttpWrapper.post(url, {
        body: data,
        headers: { accept: 'application/json' }
      });

      window.open(returnUrl, '_self');
    } catch (err) {
      this.showSubmitError(err.body ? err.body.errorCode : '', err.status);
    }
  }

  showSubmitError(errorCode: string, status?: number) {
    if (errorCode === STATE_INVALID) {
      this.showLinkExpired = true;
      return;
    }

    this.isPasswordInvalid = errorCode === PASSWORD_POLICY;
    this.submitErrorKey = this.isPasswordInvalid ? 'passwordDoesNotMeetRules' : requestErrorKey(status);
  }

  async goToLogin(): Promise<void> {
    window.open(this.loginUrl || config.learnServiceUrl, '_self');
  }
}
